import { Action } from 'redux';
import { ILinkMap } from 'DataLibrary/Tss/ILinkMap';
import { Id } from "NSwag/ServerClient/Client.nswag";
import { IHashMap } from 'DataLibrary/Common/IHashMap';

/**
 * Defines actions that can be performed for the
 * Detector Mappings in the store.
 */
export enum LinkMapActionTypes {
    AddMaps = 'ADD_LINK_MAPS',
    ModifyMaps = 'MODIFY_LINK_MAPS',
    DeleteMaps = 'DELETE_LINK_MAPS'
}

export interface AddLinkMaps extends Action {
    type: LinkMapActionTypes.AddMaps;
    linkMaps: IHashMap<ILinkMap>;
}

export interface ModifyLinkMaps extends Action {
    type: LinkMapActionTypes.ModifyMaps;
    linkMaps: IHashMap<ILinkMap>;
}

export interface DeleteLinkMaps extends Action {
    type: LinkMapActionTypes.DeleteMaps;
    ids: Id[];
}